
import { storageService } from "../../services/StorageService.js"
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

// using this with MySchools to update an existing school
export function update_school({ state, dispatch }, payload){


  var school=payload.school;
  var credentials=payload.credentials;


  // check if new school already in list
  var hasSchool= state.user_schools.find(school => (
    school.url === credentials.url &&
    school.username === credentials.username &&
    school.password === credentials.password
    ))

  if(hasSchool){
    modalService.createAlert(i18n.t("language.user_already_present")).then(
      () => {
      }
    )
    return Promise.reject();
  }


  // login if we can...
  return new Promise((resolve,reject)=>{

    dispatch('login',{school:credentials}).then(()=>{
      // login succesfull

      // ideally should use an mutation here?!
      school.username=credentials.username;
      school.password=credentials.password;
      school.url=credentials.url;

      // and save in local
      var user_schools=[...state.user_schools];
      storageService.setItem('user_schools', JSON.stringify(user_schools) );

      resolve();
    },()=>{
      reject();
    })


})

      
  }